module.exports = __webpack_public_path__ + "img/vegetable-olives-350x184.bc25cf7a.jpg";